import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LogsTab from '../../../../../../components/account-management/settings/logs-tab/LogsTab';
import Loader from '../../../../../../components/shared/custom-components/Loader';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/settings/logs',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: LogsTab as any,
});
